import React from 'react';
import ThemedList from 'components/atoms/ThemedList';
import ThemedBlock from 'components/atoms/ThemedBlock';
import EmployeeCard, { EmployeeCardShowConstants, EmployeeCardShowDefault, EmployeeCardShowValues } from 'components/molecules/EmployeeCard';
import _ from "lodash";
import FetchCachedEmployee from 'utils/fetch/cached/FetchCachedEmployee'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import ThemedPressable from 'components/atoms/ThemedPressable'
import HelperString from 'utils/helper-string'
import NoResultsView from 'components/atoms/NoResultsView'
import isEqual from 'react-fast-compare'
import { layoutStyles } from 'styles/layout'
import HelperDate from 'utils/helper-date'
import { StyleSheet } from 'react-native'

export const EmployeeListModes = {
	DEFAULT: 'default',
	PRESENCE: 'presence',
	ERO: 'ero',
	CONFIDANT: 'confidant'
}

const EmployeeList = ( { employees , mode = 'default', showHeart = false, avatarShowIconEro = true, avatarShowIconConfidant = true, onPress = null, selectedDate = HelperDate.date(), showSelf = false, showDetails = false, noResultText = null, scrollEnabled = true } = {}) => {
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	
	if( !showSelf ) {
		employees = _.filter( employees, ( o ) => {
			return o.guid !== _employee.guid;
		} );
	}
	
	if( _.size( employees ) === 0 && noResultText ) {
		return (
			<NoResultsView>
				{ noResultText }
			</NoResultsView>
		);
	}
	
	let show = EmployeeCardShowDefault;
	
	switch( mode ) {
		case EmployeeListModes.PRESENCE:
			show = {
				[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.ALWAYS,
				[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.ALWAYS
			};
			break;
			
		case EmployeeListModes.ERO:
			show = {
				[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.ALWAYS,
				[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.ALWAYS
			};
			break;
		
		case EmployeeListModes.CONFIDANT:
			show = {
				[ EmployeeCardShowConstants.STATUS_TODAY ]: EmployeeCardShowValues.IF_IS_NOT_EMPTY,
				[ EmployeeCardShowConstants.LOCATION_TODAY ]: EmployeeCardShowValues.ALWAYS
			};
			break;
	}
	
	const onItemsVisible = ( items ) => {
		const guids = items.map( o => {
			return o.item.guid;
		} )
		
		FetchCachedEmployee.fetchEasy({
			employee_guids: guids,
			details: showDetails
		})
	}
	
	const renderEmployee = ( { item } ) => {
		const employeeCard = (
			<EmployeeCard
				key={ HelperString.hash( `employee_card`, item.guid ) }
				employee={ item }
				show={ show }
				avatarShowIconEro={ avatarShowIconEro }
				avatarShowIconConfidant={ avatarShowIconConfidant }
				showHeart={ showHeart }
				selectedLocationDate={ selectedDate }
				showDetails={ showDetails }
			/>
		);
		
		const content = onPress === null ? employeeCard : (
			<ThemedPressable
				key={ HelperString.hash( `employee_card_touchable`, item ) }
				onPress={ onPress.bind( this, item )}>
				
				{ employeeCard }
			</ThemedPressable>
		);

		return content;
	}
	
	return (
		<ThemedBlock
			shadow
			containerStyle={ scrollEnabled ? layoutStyles.flexOne : {} }
			style={ scrollEnabled ? layoutStyles.flexOne : {} }>
			
			<ThemedList
				data={ employees }
				renderItem={ renderEmployee }
				style={ staticStyles.themedListPaddingHorizontal0 }
				onItemsVisible={ onItemsVisible }
				scrollEnabled={ scrollEnabled }
				numColumns={ 1 }
				dividerEnabled={ true }
			/>
		</ThemedBlock>
	);
}

const staticStyles = StyleSheet.create({
	themedListPaddingHorizontal0: {
		paddingHorizontal: 0,
	},
});

export default React.memo( EmployeeList, isEqual );
